export default __webpack_public_path__ + "static/media/10d.937cab08.png";